// extracted by mini-css-extract-plugin
export default {"opType":"style_opType__7VoQf","loading":"style_loading__6SEn+","opTypeName":"style_opTypeName__Jvvlv","body":"style_body__jTy0x"};